import { render, staticRenderFns } from "./TicketingWindow.vue?vue&type=template&id=b3308608&scoped=true&lang=pug&"
import script from "./TicketingWindow.vue?vue&type=script&lang=ts&"
export * from "./TicketingWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3308608",
  null
  
)

export default component.exports